import { render, staticRenderFns } from "./ProductVersionsRow.vue?vue&type=template&id=1e5aaa16&"
import script from "./ProductVersionsRow.vue?vue&type=script&lang=js&"
export * from "./ProductVersionsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports